import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCollaborators } from "~/store/ducks/portalrh/actionTypes";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import pagination from "~/components/pagination/currentSizePerPage/10";
import { withNamespaces } from "react-i18next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { getCollaboratorData } from "~/store/ducks/collaboratorPersonalData/actionTypes";

function TableRhCollaborator({ onTakeNavOnBolean, t }) {
  const [collaboratorsFiltered, setCollaboratorsFiltered] = useState([]);

  const dispatch = useDispatch();
  const { collaborators } = useSelector((state) => state.portalrhReducer);
  const { collaboratorData } = useSelector((state) => state.personalReducer);

  useEffect(() => {
    dispatch(getCollaborators());
    dispatch(getCollaboratorData());
  }, [dispatch]);

  //adding new propertie lepPssNum and filtering
  useEffect(() => {
    if (collaboratorData.length > 0 && collaborators.length > 0) {
      for (let i = 0; i < collaboratorData.length; i++) {
        for (let k = 0; k < collaborators.length; k++) {
          if (collaboratorData[i].lepNum === collaborators[k].funcionarioNum) {
            collaborators[k].pssNum = collaboratorData[i].lepPssNum;
            let newCollab = collaborators.filter((e) => e.funcionarioNum);
            setCollaboratorsFiltered(newCollab);
          }
        }
      }
    }
  }, [collaboratorData, collaborators]);

  // useEffect(() => {
  //   if (collaborators.length > 0) {
  //     let newCollab = collaborators.filter((e) => e.funcionarioNum);
  //     setCollaboratorsFiltered(newCollab);
  //   }
  // }, [collaborators]);

  const { SearchBar } = Search;
  const columns = [
    {
      dataField: "username",
      text: "Username",
      sort: true,
      style: { fontSize: "12px" },
    },
    {
      dataField: "funcionarioNum",
      text: t(`portalrh.NavBar.collaboratorNum`),
      sort: true,
      style: { fontSize: "12px" },
    },
    {
      dataField: "nome",
      text: t(`portalrh.NavBar.Name`),
      sort: true,
      style: { fontSize: "12px" },
    },
  ];

  const rowEventEditMod = {
    onClick: (e, row, rowIndex) => {
      onTakeNavOnBolean(true, row);
    },
  };

  const rowStyle = { cursor: "pointer" };
  return (
    <div className="custom-table custom-table-small cursor-pointer">
      {collaboratorsFiltered.length > 0 ? (
        <ToolkitProvider
          keyField="id"
          data={collaboratorsFiltered}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <SearchBar {...props.searchProps} />
              <hr />
              <BootstrapTable
                {...props.baseProps}
                rowEvents={rowEventEditMod}
                striped
                hover
                condensed
                bootstrap4
                noDataIndication="Data not found"
                rowStyle={rowStyle}
                pagination={
                  collaborators.length > 10
                    ? paginationFactory(pagination)
                    : null
                }
              />
            </div>
          )}
        </ToolkitProvider>
      ) : null}
    </div>
  );
}

export default withNamespaces()(TableRhCollaborator);
